package dev.lingvo.site.pages.docs

import androidx.compose.runtime.Composable
import dev.lingvo.site.ds.LCodeBlock
import dev.lingvo.site.i18n.t

@Composable
internal fun ReferenceCode(text: String) {
    LCodeBlock(
        text = text,
        label = t("docs.reference_components.code_example", "Code example"),
        copyable = true,
        maxLines = 32,
    )
}
